// extracted by mini-css-extract-plugin
export default {"Octicon":"use-milestone-editor-module__Octicon__WkySydz"};